/** A unique object representing a loading state. */
export const LOADING = Symbol.for("LOADING");
export type LOADING = typeof LOADING;

export function loadingFallback<T, TFallback>(value: T | LOADING | undefined, fallback: TFallback): T | TFallback {
    return value === LOADING || value === undefined ? fallback : value;
}
